import apiFetch from '../apiFetch'

export default function (idAlbaranManual) {
  return apiFetch({endPoint: `AlbaranManual/getAlbaran?idAlbaranManual=${idAlbaranManual}`, method: 'GET'})
}
